const text = `## Real-time Availability Implementation

### PRE-REQUISITES
&nbsp
1. Create a Developers account.
2. Create a license (API keys) and setup callback URLs for required events for specified facilities.
`;

export default text;



// WEBPACK FOOTER //
// ./src/components/guides/RealTimeAvailability/RealTimeAvailabilityText2.js